import { createI18n } from 'vue-i18n'

export const i18n = createI18n({
  legacy: false,
  locale: 'zh-CN',
  fallbackLocale: 'zh-CN',
  messages: {
    'zh-CN': { common: { announcements: '实时公告', back: '返回' } },
    en: { common: { announcements: 'Notices', back: 'Back' } },
  },
})

